import assets from './assets-list';

console.log(assets);

export default class AssetManager {
    static getAsset(asset) {
        if (!assets.hasOwnProperty(asset)) {
            console.error(`Could not find asset by name "${asset}"`)

            return null;
        }

        return assets[asset];
    }
}